// libraries
import { v4 } from "uuid";
import { humanByteSize } from "./bytes";

export const isPdf = (fileType?: string | null): boolean => {
  return Boolean(fileType?.includes("pdf"));
};

export const isImage = (fileType?: string): boolean => {
  return Boolean(fileType?.includes("img") || fileType?.includes("image"));
};

/**
 * return file uuid
 */
export function fileUUID(): string {
  return v4();
}

/**
 * Returns the extension of the file. e.g., `.pdf` or `.jpeg`
 * @param filename {string}
 * @returns string
 */
export function getFileExtension(filename: string): string {
  const match = filename.match(/(\.\w+)$/);
  return match ? match[0] : "";
}
/**
 * Returns Size in readable
 * @param size
 * @returns string
 */
export const convertToReadableSize = (size: number) => {
  return humanByteSize(size, false, 2);
};

/**
 * GCP storage ref utility - get the bucket that corresponds to the file ref
 *
 * `gs://{bucket}/{fullPath}`
 */
export function getBucketFromRef(url: string): string | undefined {
  if (!url.startsWith("gs://")) {
    return undefined;
  }

  return url.replace("gs://", "").split("/")[0];
}

/**
 * GCP storage ref utility - get the full path of the file within a given bucket
 *
 * `gs://{bucket}/{fullPath}`
 */
export function getFullPathFromRef(url: string): string | undefined {
  if (!url.startsWith("gs://")) {
    return undefined;
  }

  return url.replace("gs://", "").split("/").slice(1).join("/");
}
